import { LoaderFunction, redirect } from 'react-router-dom';

export const redirectLoader = (path: string): LoaderFunction => {
  return ({ request }) => {
    const url = new URL(request.url);
    return redirect(`${path}${url.search}`);
  };
};
